import { render, staticRenderFns } from "./MenusPlan.vue?vue&type=template&id=7f501e4f&"
import script from "./MenusPlan.vue?vue&type=script&lang=js&"
export * from "./MenusPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports